/** The shared "Delete {name}?" confirmation block for bucket rows and detail. */
export function DeleteBucketConfirmation({
  name,
  busy,
  className,
  onCancel,
  onConfirm
}: {
  name: string;
  busy: boolean;
  className?: string;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <div className={['delete-confirmation', className].filter(Boolean).join(' ')} role="alert">
      <strong>Delete {name}?</strong>
      <p>This permanently removes the bucket and its fields.</p>
      <div>
        <button
          type="button"
          className="button button--secondary button--pill"
          disabled={busy}
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="button button--danger button--pill"
          disabled={busy}
          aria-busy={busy}
          onClick={onConfirm}
        >
          Delete permanently
        </button>
      </div>
    </div>
  );
}
